import { url_servicios } from 'app/domain/publico';
import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class CorreoService {
    constructor(private http: Http) {
        var headers = new Headers();
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("key_apm"));
        this.options = new RequestOptions({ headers: headers });
    }

    options;


    enviar_voucher(email, html,codigo) {
        var titulo = "Voucher de Liquidación - Cod. Pago "+codigo;


        var method = "acceso/email?qr=" + "as" + "&toEmail=" + email + "&title=" + titulo + "&body=" + this.convertir_base64(html)+"&numero="+codigo;
        return this.http.post(url_servicios + method, "", this.options)
            .map(resp => resp.json());
    }

    convertir_base64(html) {
        var base64 = this.b64EncodeUnicode(html);

        //this.descriptores = (this.normas[i].palClavePri).split(",");

        for (let i of base64.split("+")) {
            base64 = base64.replace('+', '-');
        }

        for (let i of base64.split("/")) {
            base64 = base64.replace('/', '_');
        }

        return base64;
    }

    private b64EncodeUnicode(str) {
        return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
            return String.fromCharCode(parseInt(p1, 16))
        }))
    }
}


// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/modulo_compartido/correo/correo.service.ts